import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FrattaleService } from './frattale.service';

@Injectable({
  providedIn: 'root'
})
export class CrosstrendService extends FrattaleService{

  constructor(@Inject(HttpClient) protected http: HttpClient) { 
    super(http) 
  }

  listaMercati(){
    return super.getMarkets()
  }

  crossTrendH1(mkt: string){
    let data = {
      action: 'crosstrend',
      cmd: 'crosstrend_h1',
      mkt: mkt
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  listaCrossTrendH1(mkt: string){
    let data = {
      action: 'crosstrend',
      cmd: 'lista_crosstrend_h1',
      mkt: mkt
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  listaCrossTrendH4(mkt: string){
    let data = {
      action: 'crosstrend',
      cmd: 'lista_crosstrend_h4',
      mkt: mkt
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  datiGrafico(mkt: string, timeframe: string, orainizio: string, orafine: string){
    let data = {
      action: 'crosstrend',
      cmd: 'dati_grafico',
      market: mkt,
      timeframe: timeframe,
      orainizio: orainizio,
      orafine: orafine
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  crosstend2Summary(timeframe: string){
    let data = {
      action: 'crosstrend',
      cmd: 'ct2_summary',
      timeframe: timeframe
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  listaCrossTrendM15(mkt: string){
    let data = {
      action: 'crosstrend',
      cmd: 'lista_crosstrend_m15',
      mkt: mkt
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  operazioniCrossTrend(mkt: string, timeframe: string){
    let data = {
      action: 'crosstrend',
      cmd: 'ct2_trades',
      market: mkt,
      timeframe: timeframe
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
}
